<template>
    <svg
        width="5"
        height="9"
        viewBox="0 0 5 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            :fill="customColor"
            d="M1.02149 9C0.768532 9 0.515397 8.89811 0.31762 8.69316C-0.0911932 8.26878 -0.107496 7.56278 0.281074 7.1163L2.56663 4.49219L0.283402 1.88627C-0.1066 1.44136 -0.0922681 0.735363 0.31547 0.30942C0.723387 -0.116524 1.36993 -0.100683 1.75993 0.344426L4.71675 3.71853C5.09367 4.14878 5.09439 4.82642 4.71907 5.25803L1.76244 8.65326C1.56126 8.88344 1.292 9 1.02149 9Z"
        />
    </svg>
</template>

<script setup>
    import { DEFAULT_BUTTON_COLOR } from '~/utils/constants';

    defineProps({
        customColor: {
            type: String,
            required: false,
            default: DEFAULT_BUTTON_COLOR
        }
    });
</script>
